import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { templatesModel } from '@/entities/templates';

// Loads one template version by id, e.g. the version an encounter pinned.
export const useDocumentTemplate = (templateId: string) => {
  const dispatch = useAppDispatch();
  const organizationId = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationID,
  );
  const enabled = useAppSelector(
    organizationModel.selectors.selectTranscriptorV2Enabled,
  );
  const language = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationLanguage,
  );
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const template = useAppSelector(
    templatesModel.selectors.selectDocumentTemplateById(templateId),
  );

  useEffect(() => {
    let active = true;
    setFailed(false);
    void dispatch(
      templatesModel.fetchDocumentTemplateById({
        id: templateId,
        organizationId,
      }),
    )
      .unwrap()
      .catch(() => {
        if (active) {
          setFailed(true);
        }
      });
    return () => {
      active = false;
    };
  }, [templateId, attempt, organizationId, language, enabled]);

  return {
    template:
      template &&
      (!template.organization_id || template.organization_id === organizationId)
        ? template
        : undefined,
    failed,
    retry: () => setAttempt((current) => current + 1),
  };
};
